import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('invoiceReport', [booksMenu])
  .controller('invoiceReportController', invoiceReportController)
  .name;
  
  
/* @ngInject */ function invoiceReportController($scope, BooksSvc, BusyScreen, Session) {
  var mVendors = [];
  var mAllOption = { id: 0, fullName: 'All Vendors' };
  $scope.reportPage = Session.getSessionURL('/InvoiceReport.aspx');

  /*---------------------------------------------*/
  /* Sets default value for the vendor typeahead */
  /*---------------------------------------------*/
  $scope.data = { vendor: mAllOption };

  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF', status: '', includeDetail: false };

  /*--------------------------*/
  /* Static array of statuses */
  /*--------------------------*/
  $scope.statuses = [
    { display: 'All', status: '' },
    { display: 'Unpaid', status: 'U' },
    { display: 'Paid', status: 'P' }
  ];

  /*****************************************************************************
   * getVendors */
  /**
   * Returns current list of vendors.
   *****************************************************************************/
  $scope.getVendors = function (text) {
    return [mAllOption].concat(
      mVendors.filter(function (v) {
        return v.fullName.toLowerCase().indexOf(text.toLowerCase()) > -1;
      })
    );
  };

  /*------------------------------------------------*/
  /* Watches for changes to the vendors selections. */
  /*------------------------------------------------*/
  $scope.$watch('data.vendor', function (vendor) {
    var vendorSelected = vendor && angular.isObject(vendor);
    $scope.req.vendorID = vendorSelected ? vendor.id : 0;
  });

  /*--------------------------------------------------------*/
  /* Works with csm-validator to insure dates are populated */
  /*--------------------------------------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;
    BooksSvc.getVendorList(true, false).then(function (resp) {
      mVendors = resp.data.sort(function (a, b) {
        return a.fullName
          .toLowerCase()
          .localeCompare(b.fullName.toLowerCase());
      });
    });
    BusyScreen.setBusy(false);
  });
}